import * as React from "react";
import {
  Grid as ChakraGrid,
  GridProps as ChakraGridProps,
} from "@chakra-ui/react";
import { omit } from "ramda";

import useViewport from "hooks/useViewport";
import { ReactFCC } from "src/types/types";

const omitProps = (props: ChakraGridProps): ChakraGridProps =>
  omit(["mobile", "tablet"], props);

const mergeProps = (
  props: ChakraGridProps,
  device: ChakraGridProps,
): ChakraGridProps => ({ ...omitProps(props), ...device });

const ResponsiveGrid: ReactFCC<
  ChakraGridProps & {
    mobile?: ChakraGridProps;
    tablet?: ChakraGridProps;
  }
> = ({ children, ...props }) => {
  const { isMobile, isTablet, isLargerThanDesktop } = useViewport();

  const resolvedProps = React.useMemo(() => {
    if (isMobile && props?.mobile) {
      return mergeProps(props, props.mobile);
    } else if (isTablet && props?.tablet) {
      return mergeProps(props, props.tablet);
    } else if (isLargerThanDesktop) {
      return omitProps(props);
    } else {
      return omitProps(props);
    }
  }, [props, isMobile, isTablet, isLargerThanDesktop]);

  return <ChakraGrid {...resolvedProps}>{children}</ChakraGrid>;
};

export default ResponsiveGrid;
